import AudioAbstract from "./audio.abstract";
export default class Notification extends AudioAbstract {
}
Notification._config = {
    src: "https://opensooqui2.os-cdn.com/myOS/audio/chat.mp3"
};
